module.exports = new __parcel__URL__("step-find-what-you-are-looking-for.38be2391.svg").toString();